import { Menu, MenuHandler, MenuList, MenuItem, Typography, IconButton } from '@material-tailwind/react';
import React, { useEffect,useState } from 'react'
import AIcon from '../../partials/AIcon';
import { useShared } from '../../../hooks/useShared'

export default function NotificationMenu() {

    const {  notifications, com, navigate, getNotifications } = useShared();
    const [isMenuOpen, setIsMenuOpen] = React.useState(false);
    //const [totalAcount, setTotalAcount] = useState(0)
    const totalAcount = Number(notifications?.tariffNotes?.length + notifications?.invoiceNotes?.length)


    useEffect(() => {
        getNotifications()
       }, [])


    const clickHandle = (note)=>{
        navigate(note)
    }

    const setNotificationView = (note, i, model="تعرفه") => {
    const ltd = note?.company ? note?.company?.name_af: note?.from?note.from?.name_af: note?.name
        return (
            <MenuItem
                key={i}
                onClick={()=>clickHandle( model==="تعرفه"? `/db/tariffs/${note?.id}`:model==="اينوايس"? `/db/invoices/${note?.id}`:'')}
                className="flex items-center gap-4 py-2  px-2 border-b"
            >

                <AIcon name="notifications-outline" size={25} className={note?.status===-1? 'text-red-900': note?.status===2? 'text-green-900':'text-blue-500'} />
                <div className="flex flex-col grow gap-1 !text-right whitespace-normal">
                    <Typography variant="small" color="gray" className="font-normal " style={{direction:'rtl'}}>
                      
                    { note?.status===1&& <> <span className="font-medium text-black amiriB">  { `  ${model} جديد`}</span>  { ` از طرف `}  {ltd}    </> }
                    

                        { note?.status===-1 &&<span className="font-medium text-red-800 amiriB"> {`${model} شماره  ${note.id} تان از طرف اتحاديه رد شد!`} </span>}
                        { note?.status===2 &&<span className="font-medium text-green-800 amiriB"> {`${model} شماره  ${note.id} تان از طرف اتحاديه تاييد شد!`} </span>}
                       
                    </Typography>
                    <Typography
                        variant="small"
                        className="flex items-center gap-1 text-xs text-gray-500"
                    >
                        <AIcon name="time-outline" className="h-3 w-3" />
                       {com.fromNow(note?.updated_at)}
                    </Typography>
                </div>

            </MenuItem>
        );
    }
    return (
        <Menu open={isMenuOpen} handler={setIsMenuOpen} placement="bottom-end"
            animate={{
                mount: { y: 0 },
                unmount: { y: 25 },
            }}>
            <MenuHandler>
                <div className='relative inline-block mt-1'>
                    <IconButton variant="text" className='text-white-500  mr-3' >
                        <AIcon size={25} name="notifications-circle-outline" className="text-white-500" />
                    </IconButton>
                    <span className="absolute top-2 right-4 inline-flex items-center justify-center px-2 py-1 text-xs font-bold leading-none 
                    text-red-100 transform translate-x-1/2 -translate-y-1/2 bg-red-600 rounded-full">{totalAcount}</span>

                </div>


            </MenuHandler>

            <MenuList className="flex flex-col gap-2 overflow-y-scroll max-h-[500px]">
            {notifications?.tariffNotes?.length>0&&  <div className=' bg-main-color text-white rounded-md px-2 py-1 text-center' dir='rtl'>شما {totalAcount} اطلاعيه دریافت کرده ايد.</div>}
                {notifications?.tariffNotes?.map((n, i) => setNotificationView(n, i))}
                {notifications?.invoiceNotes?.map((n, i) => setNotificationView(n, i, "اينوايس"))}

               
            </MenuList>
        </Menu>
    )
}
